/* ==========================================================================
   Bazan 2026 product — variant sync (vanilla, no theme.js dependency).
   Reads variant JSON, syncs selected options -> hidden id, price, ATC,
   gallery, URL, and per-card option prices.
   ========================================================================== */
(function () {
  'use strict';

  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var withThousands = amount.replace(/\d(?=(\d{3})+\.)/g, '$&,');
    var noDecimals = Math.round(cents / 100).toLocaleString('en-US');
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withThousands)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
  }

  function initProduct(root) {
    var dataEl = root.querySelector('[data-bz-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    var idInput = root.querySelector('[data-bz-variant-id]');
    var priceCurrent = root.querySelector('[data-bz-price] .bz-product__price-current');
    var priceCompare = root.querySelector('[data-bz-price] .bz-product__price-compare');
    var atc = root.querySelector('[data-bz-atc]');
    var atcText = root.querySelector('[data-bz-atc-text]');
    var optionInputs = Array.prototype.slice.call(root.querySelectorAll('.bz-product__option-input'));

    // dynamic price suffix (label title of active priced option)
    var suffixEl = root.querySelector('[data-bz-suffix]');
    var suffixDynamic = root.getAttribute('data-bz-suffix-dynamic') === 'true';
    var priceOptIdx = parseInt(root.getAttribute('data-bz-price-option'), 10);
    var valueTitles = {};
    var titlesEl = root.querySelector('[data-bz-value-titles]');
    if (titlesEl) { try { valueTitles = JSON.parse(titlesEl.textContent) || {}; } catch (e) { valueTitles = {}; } }
    var sizeLabelEl = root.querySelector('[data-bz-size-label]');
var sizeSepEl = root.querySelector('[data-bz-size-sep]');
var sizeDesEl = root.querySelector('[data-bz-size-des]');
var sizeOptIdx = parseInt(root.getAttribute('data-bz-size-option'), 10);
var valueDesMap = {};
var desEl = root.querySelector('[data-bz-value-des]');
if (desEl) { try { valueDesMap = JSON.parse(desEl.textContent) || {}; } catch (e) { valueDesMap = {}; } }

    function updateSuffix() {
      if (!suffixDynamic || !suffixEl || isNaN(priceOptIdx)) return;
      var val = selectedOptions()[priceOptIdx];
      suffixEl.textContent = (val != null && valueTitles[val]) ? '/ ' + valueTitles[val] : '';
    }
function updateSizeInfo() {
  if (isNaN(sizeOptIdx)) return;
  var val = selectedOptions()[sizeOptIdx];
  var des = (val != null && valueDesMap[val]) ? valueDesMap[val] : '';
  if (sizeDesEl) {
    sizeDesEl.textContent = des;
    sizeDesEl.style.display = des ? '' : 'none';
  }
}

    function selectedOptions() {
      var opts = [];
      var groups = {};
      optionInputs.forEach(function (i) {
        var idx = parseInt(i.getAttribute('data-bz-option-index'), 10);
        if (i.checked) groups[idx] = i.value;
      });
      Object.keys(groups).sort(function (a, b) { return a - b; }).forEach(function (k) {
        opts[k] = groups[k];
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return opts[i] == null || val === opts[i]; })
          && opts.every(function (val, i) { return val == null || v.options[i] === val; });
      });
    }

    var viewport = root.querySelector('.bz-product__viewport');
    var track = root.querySelector('[data-bz-track]');
    var thumbsWrap = root.querySelector('[data-bz-thumbs]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.bz-product__slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-bz-thumb]'));
    var userHasInteracted = false;

    function syncHeight(index) {
      if (!viewport) return;
      var i = (typeof index === 'number') ? index : currentIndex();
      var s = slides[i];
      if (!s) return;
      var img = s.querySelector('img');
      var h = img ? img.clientHeight : s.offsetHeight;
      if (h) viewport.style.height = h + 'px';
    }

    function centerThumb(index) {
      var t = thumbs[index];
      if (!t || !thumbsWrap) return;
      var left = t.offsetLeft - thumbsWrap.offsetLeft - (thumbsWrap.clientWidth - t.clientWidth) / 2;
      thumbsWrap.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }

    function setActiveIndex(index) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
      thumbs.forEach(function (t) {
        var ti = parseInt(t.getAttribute('data-bz-thumb-index'), 10);
        t.classList.toggle('is-active', ti === index);
      });
      syncHeight(index);
      centerThumb(index);
    }
    function scrollToIndex(index) {
      if (!track || !slides[index]) return;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActiveIndex(index);
    }
    function currentIndex() {
      if (!track) return 0;
      var c = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestDist = Infinity;
      slides.forEach(function (s, i) {
        var center = s.offsetLeft - track.offsetLeft + s.clientWidth / 2;
        var d = Math.abs(center - c);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    function updateGallery(variant) {
  if (!userHasInteracted) return;
  if (!variant || variant.featured_media == null) return;
  var mediaId = String(variant.featured_media.id);
  var idx = slides.findIndex(function (s) { return s.getAttribute('data-bz-media') === mediaId; });
  if (idx >= 0) scrollToIndex(idx);
}


    function getSealPlanId() {
      var inp = root.querySelector('.bz-product__subscribe [name="selling_plan"]')
        || document.querySelector('.bz-product__subscribe [name="selling_plan"]')
        || document.querySelector('[name="selling_plan"]');
      return inp && inp.value ? String(inp.value).trim() : '';
    }

    function updateCardPrices() {
      var cards = root.querySelectorAll('.bz-product__option--cards');
      if (!cards.length) return;
      var opts = selectedOptions();
      cards.forEach(function (fs) {
        var lastIdx = parseInt(fs.getAttribute('data-bz-option-index'), 10);
        fs.querySelectorAll('[data-bz-option-price]').forEach(function (priceEl) {
          var val = priceEl.getAttribute('data-bz-option-price');
          var probe = opts.slice();
          probe[lastIdx] = val;
          var v = findVariant(probe);
          var wrap = priceEl.parentNode;
          var cmpEl = wrap.querySelector('[data-bz-option-compare="' + (window.CSS && CSS.escape ? CSS.escape(val) : val) + '"]');
          var discEl = wrap.querySelector('[data-bz-option-discount="' + (window.CSS && CSS.escape ? CSS.escape(val) : val) + '"]');
          if (!v) {
            priceEl.textContent = '';
            if (cmpEl) cmpEl.textContent = '';
            if (discEl) discEl.textContent = '';
            return;
          }
          // price reflects the active Seal selling plan when one is selected
          var planId = getSealPlanId();
          var finalPrice = v.price;
          var finalCompare = v.compare_at_price;
          if (planId && v.selling_plan_allocations && v.selling_plan_allocations.length) {
            var alloc = v.selling_plan_allocations.filter(function (a) {
              return String(a.selling_plan_id) === String(planId);
            })[0] || v.selling_plan_allocations[0];
            if (alloc) {
              finalPrice = alloc.price;
              finalCompare = alloc.compare_at_price || v.price;
            }
          }
          priceEl.textContent = formatMoney(finalPrice);
          // only show compare + discount for a subscription plan (hide for one-time)
          var hasSale = planId && finalCompare && finalCompare > finalPrice;
          if (cmpEl) cmpEl.textContent = hasSale ? formatMoney(finalCompare) : '';
          if (discEl) {
            if (hasSale) {
              var pct = Math.round((finalCompare - finalPrice) / finalCompare * 100);
              discEl.textContent = 'Save ' + pct + '%';
            } else {
              discEl.textContent = '';
            }
          }
        });
      });
    }

    function update() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      updateCardPrices();
      updateSuffix();
      updateSizeInfo();

      if (!variant) {
        if (atc) { atc.disabled = true; }
        if (atcText) { atcText.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = variant.id;
      // main price reflects selected variant + active Seal plan
      var mPrice = variant.price;
      var mCompare = variant.compare_at_price;
      var mPlan = getSealPlanId();
      if (mPlan && variant.selling_plan_allocations && variant.selling_plan_allocations.length) {
        var mAlloc = variant.selling_plan_allocations.filter(function (a) {
          return String(a.selling_plan_id) === String(mPlan);
        })[0] || variant.selling_plan_allocations[0];
        if (mAlloc) {
          mPrice = mAlloc.price;
          mCompare = mAlloc.compare_at_price || variant.price;
        }
      }
      if (priceCurrent) priceCurrent.textContent = formatMoney(mPrice);
      root.dispatchEvent(new CustomEvent('bz:variant', { bubbles: false, detail: { price: mPrice } }));
      if (priceCompare) {
        if (mCompare && mCompare > mPrice) {
          priceCompare.textContent = formatMoney(mCompare);
          priceCompare.style.display = '';
        } else {
          priceCompare.style.display = 'none';
        }
      }
      if (atc) atc.disabled = !variant.available;
      if (atcText) {
        atcText.textContent = variant.available
          ? (atc.getAttribute('data-default-text') || atcText.getAttribute('data-default') || atcText.textContent.trim() || 'Add to cart')
          : 'Sold out';
        if (variant.available && atc.dataset.atcLabel) atcText.textContent = atc.dataset.atcLabel;
      }
      updateGallery(variant);

      // update URL without reload
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      updateOptionVisibility()
    }
function updateOptionVisibility() {
  var fieldsets = Array.prototype.slice.call(root.querySelectorAll('fieldset[data-bz-option-index]'));

  fieldsets.forEach(function(fieldset) {
    var optionIndex = parseInt(fieldset.getAttribute('data-bz-option-index'), 10);

    var selectedBefore = [];
    fieldsets.forEach(function(fs) {
      var fsIndex = parseInt(fs.getAttribute('data-bz-option-index'), 10);
      if (fsIndex < optionIndex) {
        var checkedInput = fs.querySelector('input[type="radio"]:checked');
        if (checkedInput) {
          selectedBefore.push({ index: fsIndex, value: checkedInput.value });
        }
      }
    });

    var validValues = [];
    variants.forEach(function(v) {
      var matches = selectedBefore.every(function(s) {
        return v.options[s.index] === s.value;
      });
      if (matches && validValues.indexOf(v.options[optionIndex]) === -1) {
        validValues.push(v.options[optionIndex]);
      }
    });

        fieldset.querySelectorAll('input[type="radio"]').forEach(function(input) {
      var isValid = validValues.indexOf(input.value) !== -1;
      var label = fieldset.querySelector('label[for="' + input.id + '"]');
      if (label) label.style.display = isValid ? '' : 'none';
      input.style.display = isValid ? '' : 'none';

      if (input.checked && !isValid) {
        var firstValidInput = fieldset.querySelector(
          'input[type="radio"][value="' + validValues[0] + '"]'
        );
        if (firstValidInput) {
          firstValidInput.checked = true;
          firstValidInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });

    // ── Reorder DOM theo thứ tự validValues (= thứ tự variants Shopify) ──
    var container = fieldset.querySelector('.bz-product__option-values');
    if (container) {
      validValues.forEach(function(val) {
        var inp = fieldset.querySelector('input[type="radio"][value="' + val + '"]');
        var lbl = inp ? fieldset.querySelector('label[for="' + inp.id + '"]') : null;
        if (inp) container.appendChild(inp);
        if (lbl) container.appendChild(lbl);
      });
    }

  }); // ← đóng fieldsets.forEach
} // ← đóng updateOptionVisibility


    // keep ATC available label
    if (atc && atcText && !atc.disabled) atc.dataset.atcLabel = atcText.textContent.trim();

    optionInputs.forEach(function (i) {
  i.addEventListener('change', function () {
    userHasInteracted = true;
    update();
  });
});


    // slider wiring
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        scrollToIndex(parseInt(thumb.getAttribute('data-bz-thumb-index'), 10));
      });
    });
    var prevBtn = root.querySelector('[data-bz-prev]');
    var nextBtn = root.querySelector('[data-bz-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollToIndex(Math.max(0, currentIndex() - 1)); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollToIndex(Math.min(slides.length - 1, currentIndex() + 1)); });
    // ---------- mobile swipe sync ----------
if (track) {
  var scrollTimer = null;
  track.addEventListener('scroll', function () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(function () {
      setActiveIndex(currentIndex());
    }, 80); // đợi scroll dừng hẳn rồi mới sync
  }, { passive: true });
}

    // ---------- desktop mouse drag ----------
if (track && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
  var isDragging = false;
  var dragStartX = 0;
  var scrollStartLeft = 0;
  var dragMoved = false;

  track.addEventListener('mousedown', function (e) {
    isDragging = true;
    dragMoved = false;
    dragStartX = e.clientX;
    scrollStartLeft = track.scrollLeft;
    track.classList.add('is-dragging');
  });

  document.addEventListener('mousemove', function (e) {
    if (!isDragging) return;
    var dx = e.clientX - dragStartX;
    if (Math.abs(dx) > 4) dragMoved = true;
    track.scrollLeft = scrollStartLeft - dx;
  });

  document.addEventListener('mouseup', function () {
  if (!isDragging) return;
  isDragging = false;
  track.classList.remove('is-dragging'); // CSS snap bật lại
  if (dragMoved) {
    var idx = currentIndex();
    // dùng đúng hàm scrollToIndex có behavior: smooth
    scrollToIndex(idx);
    dragMoved = false;
  }
});



  // chặn click sau khi drag
  track.addEventListener('click', function (e) {
    if (dragMoved) { e.preventDefault(); e.stopPropagation(); dragMoved = false; }
  }, true);
}

    // recalc height when images finish loading or on resize
    slides.forEach(function (s) {
      var img = s.querySelector('img');
      if (img && !img.complete) {
        img.addEventListener('load', function () {
          if (s.classList.contains('is-active')) syncHeight();
        });
      }
    });
    // drop the dot separator on the last badge of each wrapped row
    var badges = Array.prototype.slice.call(root.querySelectorAll('.bz-product__badge'));
    function markBadgeRowEnds() {
      badges.forEach(function (b, i) {
        var next = badges[i + 1];
        var rowEnd = !next || (next.offsetTop - b.offsetTop) > 4;
        b.classList.toggle('is-row-end', rowEnd);
      });
    }

    window.addEventListener('resize', function () { syncHeight(); markBadgeRowEnds(); });

    setActiveIndex(0);
    syncHeight(0);
    markBadgeRowEnds();
    window.addEventListener('load', markBadgeRowEnds);
    setTimeout(markBadgeRowEnds, 300);

    updateCardPrices();
    updateSuffix();
    updateSizeInfo();
    // re-price cards when the Seal subscription plan changes
    initSealPricing();
    function initSealPricing() {
      var scope = root.querySelector('.bz-product__subscribe') || document;
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        var sealOptions = scope.querySelectorAll('.sls-option-container');
        if (sealOptions.length) {
          clearInterval(poll);
          update();
          sealOptions.forEach(function (opt) {
            opt.addEventListener('click', function () {
              setTimeout(update, 120);
            });
          });
          var planInput = scope.querySelector('[name="selling_plan"]');
          if (planInput) {
            planInput.addEventListener('change', function () { update(); });
          }
          var sel = scope.querySelector('select[name="subs_interval"]');
          if (sel) sel.addEventListener('change', function () { setTimeout(update, 120); });
        }
        if (attempts > 50) clearInterval(poll);
      }, 200);
    }
  }

  function initCountdown(root) {
    var el = root.querySelector('[data-bz-countdown]');
    if (!el) return;
    var totalSecs = parseInt(el.getAttribute('data-bz-countdown'), 10);
    if (!totalSecs || totalSecs <= 0) return;
    var endTime = Date.now() + totalSecs * 1000;

    var dEl = el.querySelector('[data-bz-cd-days]');
    var hEl = el.querySelector('[data-bz-cd-hours]');
    var mEl = el.querySelector('[data-bz-cd-mins]');
    var sEl = el.querySelector('[data-bz-cd-secs]');

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function tick() {
      var diff = Math.max(0, endTime - Date.now());
      var total = Math.floor(diff / 1000);
      var d = Math.floor(total / 86400);
      var h = Math.floor((total % 86400) / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;
      if (dEl) dEl.textContent = pad(d);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
      if (diff <= 0) { clearInterval(timer); el.style.display = 'none'; }
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  function initShippingEstimate(root) {
    var el = root.querySelector('[data-bz-shipping]');
    if (!el) return;
    var datesEl = el.querySelector('[data-bz-shipping-dates]');
    if (!datesEl) return;

    var minDays = parseInt(el.getAttribute('data-bz-shipping-min'), 10) || 0;
    var maxDays = parseInt(el.getAttribute('data-bz-shipping-max'), 10) || minDays;

    var dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    function formatDate(d) {
      return dayNames[d.getDay()] + ', ' + monthNames[d.getMonth()] + ' ' + d.getDate();
    }

    var today = new Date();
    var start = new Date(today);
    start.setDate(start.getDate() + minDays);
    var end = new Date(today);
    end.setDate(end.getDate() + maxDays);

    datesEl.textContent = formatDate(start) + ' - ' + formatDate(end);
  }

  function initStickyAtc(root) {

    var bar = root.querySelector('[data-bz-sticky]');
    if (!bar) return;

    var mainBtn = root.querySelector('[data-bz-atc]');
    var stickyBtn = bar.querySelector('[data-bz-sticky-btn]');
    var labelEl = bar.querySelector('[data-bz-sticky-label]');
    var priceEl = bar.querySelector('[data-bz-sticky-price]');
    var freqSel = bar.querySelector('[data-bz-sticky-freq]');
    var planRow = bar.querySelector('[data-bz-sticky-row]');

    // ── Price sync ──
    var stickyIsSubscribe = false;
    var variantIdEl = root.querySelector('[data-bz-variant-id]');
    var variantsDataEl = root.querySelector('[data-bz-variants]');
    var stickyVariants = [];
    if (variantsDataEl) { try { stickyVariants = JSON.parse(variantsDataEl.textContent); } catch (e) {} }

    function syncPrice() {
      if (!priceEl || !variantIdEl) return;
      var id = parseInt(variantIdEl.value, 10);
      for (var i = 0; i < stickyVariants.length; i++) {
        if (stickyVariants[i].id === id) { priceEl.textContent = formatMoney(stickyVariants[i].price); return; }
      }
    }
    syncPrice();

    root.addEventListener('bz:variant', function (e) {
      if (!priceEl || !e.detail) return;
      if (stickyIsSubscribe) {
        priceEl.textContent = formatMoney(e.detail.price);
      } else {
        syncPrice();
      }
    });

    // ── Sticky button → main ATC ──
    if (stickyBtn && mainBtn) {
      stickyBtn.addEventListener('click', function () {
        mainBtn.click();
        if (labelEl) {
          var orig = labelEl.textContent;
          labelEl.textContent = 'Added!';
          stickyBtn.classList.add('is-added');
          stickyBtn.disabled = true;
          setTimeout(function () {
            labelEl.textContent = orig;
            stickyBtn.classList.remove('is-added');
            stickyBtn.disabled = false;
          }, 2000);
        }
      });
    }

        // ── Hiện bar khi top của .sls-option-container.sls-active (fallback .bz-product__countdown) chạm tới top viewport ──
    if (mainBtn) {
      var ticking = false;
      function checkStickyVisibility() {
        var target = document.querySelector('.sls-option-container.sls-active')
                  || root.querySelector('.bz-product__countdown');
        if (!target) return;
        var show = target.getBoundingClientRect().top <= 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        ticking = false;
      }
      checkStickyVisibility();
      window.addEventListener('scroll', function () {
        if (!ticking) {
          requestAnimationFrame(checkStickyVisibility);
          ticking = true;
        }
      }, { passive: true });
    }


    // ── Sản phẩm không có subscription: không cần Seal sync ──
    if (!planRow || planRow.hasAttribute('data-bz-sticky-onetime')) return;

    // ── Poll cho Seal Subscriptions load xong ──
    var pollCount = 0;
    var poll = setInterval(function () {
      pollCount++;
      var sealOpts = Array.prototype.slice.call(
        root.querySelectorAll('.bz-product__subscribe .sls-option-container')
      );
      if (sealOpts.length) {
        clearInterval(poll);

        var mainFreq = root.querySelector('.bz-product__subscribe select[name="subs_interval"]');
        if (mainFreq && freqSel && mainFreq.options.length) {
          freqSel.innerHTML = mainFreq.innerHTML;
          freqSel.value = mainFreq.value;
        }

        var radios = Array.prototype.slice.call(bar.querySelectorAll('input[type="radio"]'));

        function setStickyState(isSubscribe) {
          stickyIsSubscribe = isSubscribe;
          bar.classList.toggle('is-subscribe', isSubscribe);
          if (radios[0]) radios[0].checked = !isSubscribe;
          if (radios[1]) radios[1].checked = isSubscribe;
          if (!isSubscribe) syncPrice();
        }

        // Sticky radio → Seal
        radios.forEach(function (radio) {
          radio.addEventListener('change', function () {
            var isSubscribe = radio.value === 'subscribe';
            setStickyState(isSubscribe);
            if (sealOpts[isSubscribe ? 1 : 0]) sealOpts[isSubscribe ? 1 : 0].click();
          });
        });

        // Sticky freq → main Seal freq
        if (freqSel && mainFreq) {
          freqSel.addEventListener('change', function () {
            mainFreq.value = freqSel.value;
            mainFreq.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }

        // Customer click vào Seal option → sync sticky (chỉ user-initiated)
        sealOpts.forEach(function (opt, idx) {
          opt.addEventListener('click', function () {
            var isSubscribe = idx === 1;
            setStickyState(isSubscribe);
            if (isSubscribe && freqSel && mainFreq) freqSel.value = mainFreq.value;
          });
        });

        // Mặc định sticky luôn là One Time (không đọc state Seal để tránh auto-sync)
        setStickyState(false);

      }

      if (pollCount > 50) clearInterval(poll);
    }, 200);
  }

  function initDescTabs(root) {
    var btns = Array.prototype.slice.call(root.querySelectorAll('[data-bz-tab-btn]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-bz-tab-panel]'));
    if (!btns.length) return;
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-bz-tab-btn');
        btns.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-bz-tab-panel') === target);
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-bz-product]').forEach(function (el) {
      initProduct(el);
      initCountdown(el);
      initShippingEstimate(el);
      initStickyAtc(el);
      initDescTabs(el);
    });
  }



  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // re-init in Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) e.target.querySelectorAll('[data-bz-product]').forEach(function (el) {
      initProduct(el);
      initCountdown(el);
      initShippingEstimate(el);
      initStickyAtc(el);
      initDescTabs(el);
    });
  });


})();
function initBzAjaxCart() {
  var form = document.querySelector('#bz-product-form');
  if (!form) return;

  // Đợi theme.AjaxProduct sẵn sàng
  if (typeof theme === 'undefined' || !theme.AjaxProduct) {
    setTimeout(initBzAjaxCart, 200);
    return;
  }

  // Truyền submit selector là button của bz-product
  new theme.AjaxProduct(form, '.bz-product__atc');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBzAjaxCart);
} else {
  initBzAjaxCart();
}